(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilDialogController', SSPerfilDialogController);

    SSPerfilDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSPerfil', 'SSActividad', 'SSAsignacion', 'ProgramaEducativo', 'SSProyecto'];

    function SSPerfilDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSPerfil, SSActividad, SSAsignacion, ProgramaEducativo, SSProyecto) {
        var vm = this;

        vm.sSPerfil = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssactividads = SSActividad.query();
        vm.ssasignacions = SSAsignacion.query();
        vm.programaeducativos = ProgramaEducativo.query();
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSPerfil.id !== null) {
                SSPerfil.update(vm.sSPerfil, onSaveSuccess, onSaveError);
            } else {
                SSPerfil.save(vm.sSPerfil, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSPerfilUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
